














































































































import {Component, Vue, Prop} from "vue-property-decorator";
import CalendarEvent from "./CalendarEvent.vue";
import CalendarEventObj from "../models/CalendarEvent";
import moment from "moment";
import {DAYS, HOUR, WEEK} from "../utils";
import axios from "axios";
import {apiGet} from "../session";
import {DATE_FORMAT} from "../models/Model";

type Moment = moment.Moment;

function getScrollbarWidth(): number {
    // https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

    document.body.appendChild(outer);
    const widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";

    // add innerdiv
    const inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;

    // remove divs
    (outer.parentNode as HTMLElement).removeChild(outer);

    return widthNoScroll - widthWithScroll;
}

@Component({
    components: {
        CalendarEvent,
    },
})
export default class WeeklyCalendar extends Vue {
    protected weekStart: Moment = moment().startOf("week");
    @Prop({default: "100%"}) protected height!: string;
    @Prop({default: false}) protected admin!: boolean;

    protected weekdays: Moment[] = [];
    protected hours = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
    protected events: CalendarEventObj[] = [];

    protected created() {
        this.generateDays();
    }

    protected generateDays() {
        this.weekdays[0] = this.weekStart;
        for (let i = 1; i < 7; i++) {
            this.weekdays[i] = moment(this.weekdays[0]).add(i, DAYS);
        }
        const fromDate = this.weekStart.clone().startOf(WEEK).format(DATE_FORMAT);
        const toDate = this.weekStart.clone().startOf(WEEK).add(6, DAYS).format(DATE_FORMAT);
        apiGet(`/events?from=${fromDate}&to=${toDate}`).then((objs) => {
            this.events.length = 0;
            for (const e of objs) {
                this.events.push(CalendarEventObj.fromJson(e));
            }
        });
    }

    protected refresh() {
        this.generateDays();
        this.$forceUpdate();
    }

    protected swSet() {
        const newStart = moment().startOf("week");
        if (!this.weekStart.isSame(newStart, "days")) {
            this.weekStart = newStart;
            this.generateDays();
            this.$forceUpdate();
        }
    }

    protected swNavigate(amount: number, units: "month" | "year" | "week") {
        this.weekStart.add(amount, units).startOf("week");
        this.generateDays();
        this.$forceUpdate();
    }

    protected newBookingClicked(evt: MouseEvent) {
        window.location = "/event/?eid=new" as unknown as Location;
    }

    protected getDaysRange() {
        const from = this.weekStart;
        const to = this.weekStart.clone().add(6, "days");
        if (from.month() === to.month()) {
            return from.format("D") + " - " + to.format("D MMM, YYYY");
        } else {
            return from.format("D MMM") + " - " + to.format("D MMM, YYYY");
        }
    }

    protected get scrollbarWidth(): number {
        return getScrollbarWidth();
    }

    protected getStartingEvents(hour: Moment): CalendarEventObj[] {
        return this.events.filter((e) => e.start.startOf(HOUR).isSame(hour));
    }

    protected manageClicked(evt: MouseEvent) {
        window.location.pathname = "/calendar";
    }

    private formatTime(time: number): string {
        return moment(time, "H").format("h A");
    }
}
